export default __webpack_public_path__ + "static/media/BSE-Logo_Color.13c97319.png";